import { IMPERSONATION_EXPIRED, START_IMPERSONATION_SUCCESS } from 'store/app/auth/action';
import authActions from 'store/app/auth/action';
import Cookie from 'services/Cookie';

let expiryTimer = null;

const clearExpiryTimer = () => {
  if (expiryTimer) {
    clearTimeout(expiryTimer);
    expiryTimer = null;
  }
};

export const impersonationMiddleware =
  ({ dispatch }) =>
  next =>
  action => {
    const result = next(action);

    if (action.type === START_IMPERSONATION_SUCCESS) {
      clearExpiryTimer();
      const { token, expiresAt } = action.payload;
      // Persist the impersonation token on the shared cookie so it survives cross-subdomain
      // navigation and page reloads (Redux impersonation state is in-memory / per-origin).
      if (token?.hash) {
        Cookie.set('impersonate', token);
      }
      const msUntilExit = new Date(expiresAt).getTime() - Date.now() - 60 * 1000;
      if (msUntilExit > 0) {
        expiryTimer = setTimeout(() => {
          dispatch(authActions.exitImpersonation({ reason: 'proactive' }));
        }, msUntilExit);
      }
    }

    if (action.type === IMPERSONATION_EXPIRED) {
      clearExpiryTimer();
      Cookie.removeAuthCookie('impersonate');
    }

    return result;
  };

export default impersonationMiddleware;
